var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { TemplateValueService } from './template-value.service';
var TemplateValueComponent = /** @class */ (function (_super) {
    __extends(TemplateValueComponent, _super);
    function TemplateValueComponent(router, route, logger, action, message, page, service, cdRef) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.cdRef = cdRef;
        _this.readonly = false;
        _this.selectedTemplate = {};
        _this.iframeCode = '<!DOCTYPE html>'
            + '<html>'
            + '<head>'
            + '<meta http-equiv="content-type" content="text/html; charset=utf-8"/>'
            + '<title>{{title}}</title>'
            + '{{css}}'
            + '{{color}}'
            + '</head>'
            + '<body>'
            + '{{html}}'
            + '{{js}}'
            + '</body>'
            + '</html>';
        return _this;
    }
    TemplateValueComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setCompRec();
    };
    TemplateValueComponent.prototype.ngAfterViewInit = function () {
        this.modal = this.remodalElement.nativeElement;
    };
    TemplateValueComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    TemplateValueComponent.prototype.onSubscribe = function (data) {
        this.setCompRec();
        this.getTemplate();
    };
    TemplateValueComponent.prototype.getTemplate = function () {
        var _this = this;
        this.service.getTemplate().subscribe(function (items) {
            _this.templates = [];
            if (typeof items !== 'undefined') {
                _this.templates = items;
                if (typeof _this.rec['template_id'] !== 'undefined') {
                    _this.orgData = $.extend(true, {}, _this.rec);
                    _this.getTemplateValues(_this.orgData['template_id'], false);
                    _this.setCompRec();
                }
            }
        });
    };
    TemplateValueComponent.prototype.getTemplateValues = function (id, change) {
        if (!id) {
            return;
        }
        var values = [];
        var template = jsonpath.value(this.templates, '$..[?(@.code==' + id + ')]');
        if (typeof template !== 'undefined') {
            this.selectedTemplate = template.data;
            var setFlg = (typeof this.orgData !== 'undefined' && this.orgData['template_id'].toString() === id.toString()) ? true : false;
            var html = template.data['html'] || '';
            var r = /\{\{(input)(\d+)\}\}/g;
            var m = void 0;
            while ((m = r.exec(html)) != null) {
                var tag = m[1] + m[2];
                var value = { tag: tag, value: null };
                if (setFlg) {
                    var val = jsonpath.value(this.orgData['values'], '$..[?(@.tag=="' + tag + '")]');
                    if (typeof val !== 'undefined') {
                        value = val;
                    }
                    if (typeof value['cdate'] !== 'undefined') {
                        delete value['cdate'];
                    }
                    if (typeof value['cby'] !== 'undefined') {
                        delete value['cby'];
                    }
                    if (typeof value['udate'] !== 'undefined') {
                        delete value['udate'];
                    }
                    if (typeof value['uby'] !== 'undefined') {
                        delete value['uby'];
                    }
                    if (typeof value['base_status'] !== 'undefined') {
                        delete value['base_status'];
                    }
                    if (change) {
                        value.value = null;
                    }
                }
                values.push(value);
            }
        }
        this.rec['values'] = values;
    };
    TemplateValueComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    TemplateValueComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#Button#preview') {
            this.openRemodal();
        }
    };
    TemplateValueComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    TemplateValueComponent.prototype.onChange = function (e) {
        this.cdRef.detectChanges();
        this.rec[e.key] = e.val;
        if (e.key === 'template_id') {
            this.getTemplateValues(e.val, true);
        }
        this.setCompRec();
    };
    TemplateValueComponent.prototype.onChangeValues = function (e, index) {
        this.rec['values'][index].value = e.val;
        this.setCompRec();
    };
    TemplateValueComponent.prototype.setCompRec = function () {
        this.action.setCompRec(this.componentName, this.rec);
    };
    TemplateValueComponent.prototype.openRemodal = function () {
        this.remodal = $(this.modal).remodal({ hashTracking: false });
        var html = this.selectedTemplate['html'] || '';
        for (var _i = 0, _a = this.rec['values']; _i < _a.length; _i++) {
            var value = _a[_i];
            html = html.replace("{{" + value.tag + "}}", value.value || '');
        }
        var color = '';
        if (this.rec['bg_color']) {
            color += "background-color: " + this.rec['bg_color'] + ";";
        }
        if (this.rec['color']) {
            color += "color: " + this.rec['color'] + ";";
        }
        if (this.rec['bg_color'] || this.rec['color']) {
            color = "<style> body { " + color + " }</style>";
        }
        var code = this.iframeCode
            .replace('{{title}}', this.selectedTemplate['title'] || 'title')
            .replace('{{css}}', this.selectedTemplate['css'] || '')
            .replace('{{js}}', this.selectedTemplate['js'] || '')
            .replace('{{color}}', color)
            .replace('{{html}}', html);
        var doc = this.iframeElement.nativeElement.contentWindow.document;
        doc.open();
        doc.write(code);
        doc.close();
        this.remodal.open();
    };
    TemplateValueComponent.prototype.trackByValue = function (index, value) {
        return value.tag;
    };
    TemplateValueComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    TemplateValueComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'contents-template-value',
                    template: "<form id=\"{{ componentName }}\">\n  <div *ngIf=\"templates\" class=\"row -mb-3\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        label: (msg | async)['au.COMPONENT.TemplateValueComponent.label.template_id'],\n        key: 'template_id',\n        controlType: 'select',\n        readonly: readonly,\n        required: true,\n        params: {\n          note: (msg | async)['au.COMPONENT.TemplateValueComponent.label.templateNote'],\n          options: templates\n        }\n      }\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n  <div class=\"row -mb-3\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['au.COMPONENT.TemplateValueComponent.label.values']}\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n        <dd class=\"form_dd\">\n          <ul>\n            <ng-template [ngIf]=\"rec?.values?.length === 0 || !rec?.values\">\n              <li class=\"form_li\">\n                <column-formlabel [col]=\"{controlType: 'label', label: (msg | async)['au.COMPONENT.TemplateValueComponent.label.noEditTag']}\"></column-formlabel>\n              </li>\n            </ng-template>\n            <ng-template ngFor let-value [ngForOf]=\"rec?.values\" let-index=\"index\" [ngForTrackBy]=\"trackByValue\">\n              <li class=\"form_li form_li-break\">\n                <column-formlabel [col]=\"{controlType: 'label', label: value.tag}\"></column-formlabel>\n              </li>\n              <li *ngIf=\"!readonly\" class=\"form_li form_li-w100per\">\n                <column-textarea [key]=\"'form'\" [col]=\"{\n                  controlType: 'textarea',\n                  key: 'value_' + value.tag,\n                  params: {options: {rows: 5}}\n                }\" [val]=\"value.value\" [msg]=\"(msg | async)\" (changeVal)=\"onChangeValues($event, index)\"></column-textarea>\n              </li>\n              <li *ngIf=\"readonly\" class=\"form_li\">\n                <column-formreadonly [col]=\"{controlType: 'textarea'}\" [val]=\"value.value\" [msg]=\"(msg | async)\"></column-formreadonly>\n              </li>\n              <li *ngIf=\"index < rec?.values?.length - 1\" class=\"form_li form_li-break\"></li>\n            </ng-template>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n  </div>\n  <div class=\"row -mb-3\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        label: (msg | async)['au.COMPONENT.TemplateValueComponent.label.bg_color'],\n        key: 'bg_color',\n        controlType: 'color',\n        readonly: readonly\n      }\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n  <div class=\"row -mb-3\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        label: (msg | async)['au.COMPONENT.TemplateValueComponent.label.color'],\n        key: 'color',\n        controlType: 'color',\n        readonly: readonly\n      }\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n  <div *ngIf=\"rec?.template_id\" class=\"row\">\n    <div class=\"col-sm-12\">\n      <btn [componentName]=\"componentName + '#Button'\"\n           [component]=\"{\n            params: {\n              buttons: [{\n                type: 'button',\n                event: componentName + '#Button#preview',\n                caption: (msg | async)['au.COMPONENTS.button.preview'],\n              params: {btnClass: {type: 'decide'}}\n            }]\n          }\n          }\"></btn>\n    </div>\n  </div>\n</form>\n\n<!-- remodal -->\n<div class=\"remodal\" id=\"{{ componentName + '#Remodal' }}\" #remodal>\n  <div style=\"height: 90%; background-color: #ffffff;\">\n    <iframe frameborder=\"1\" width=\"100%\" height=\"100%\" #iframe></iframe>\n  </div>\n  <div class=\"remodal_btns\">\n    <ul class=\"remodal_btns_group\">\n      <li>\n        <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\">{{ (msg | async)['au.COMPONENTS.modal.button.close'] }}</button>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n"
                }] }
    ];
    /** @nocollapse */
    TemplateValueComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: TemplateValueService },
        { type: ChangeDetectorRef }
    ]; };
    TemplateValueComponent.propDecorators = {
        iframeElement: [{ type: ViewChild, args: ['iframe',] }],
        remodalElement: [{ type: ViewChild, args: ['remodal',] }]
    };
    return TemplateValueComponent;
}(ContentBaseComponent));
export { TemplateValueComponent };
//# sourceMappingURL=template-value.component.js.map